<template>
  <vue3-chart-js
    ref="chartRef"
    :id="areaChart.id"
    :type="areaChart.type"
    :data="areaChart.data"
    :options="areaChart.options"
  ></vue3-chart-js>
</template>

<script>
import { ref } from 'vue'
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs"
import 'chartjs-adapter-date-fns';

var chartOptions = {
  maintainAspectRatio: true,
  responsive: true,
  borderWidth: 2.5,
  animation: {
    duration: 500
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      displayColors: false,
      yAlign: "bottom",
    },
  },
  interaction: {
    mode: "index",
    intersect: false,
    axis: "x",
  },
  scales: {
    x: {
      type: "time",
      time: {
        unit: "hour"
      }
    },
    y: {
      beginAtZero: true,
    },
  },
  elements: {
    point: {
      pointRadius: 0,
    },
  },
  layout: {
    padding: {
      top: 20,
      left: 10,
      right: 10,
      bottom: 10,
    },
  },
}

export default {
  name: "Chart",
  components: {
    Vue3ChartJs,
  },
  props: {
    areaData: Array,
    areaLabels: Array,
    sampleData: Array
  },
  setup(props) {
    const chartRef = ref(null)

    const chartDetails = {
      labels: props.areaLabels,
      datasets: [
        {
          label: 'Customers Affected',
          data: props.areaData,
          borderColor: "rgb(24, 144, 255)",
          tension: 0.1,
          fill: true,
          backgroundColor: 'rgb(24, 144, 255, 0.05)',
        },
      ],
    }
    const areaChart = {
      id: "line",
      type: "line",
      data: chartDetails,
      options: chartOptions,
    }

    return {
      areaChart,
      chartRef
    }
  },
  watch: {
    areaLabels: {
      deep: true,
      handler() {
        this.chartRef.update(150)
      }
    },
    sampleData: {
      deep: true,
      handler() {
        console.log(this.sampleData)
      }
    }
  },
}
</script>

<style>
#chart {
  position: relative;
  margin: auto;
  height: 100%;
  width: 100%;
}
</style>